import { useEffect, useCallback, createContext } from "react";
import { API } from "utils/api";
import { showError } from "utils/common";
import { SET_SITE_INFO } from "store/actions";
import { useDispatch } from "react-redux";

export const LoadStatusContext = createContext();

const isLocalPreview = () => ['localhost', '127.0.0.1'].includes(window.location.hostname);

// eslint-disable-next-line
const StatusProvider = ({ children }) => {
  const dispatch = useDispatch();

  const loadBackupSiteInfo = useCallback(() => {
    const backupSiteInfo = localStorage.getItem("siteInfo");
    if (!backupSiteInfo) {
      return "";
    }

    const data = JSON.parse(backupSiteInfo);
    dispatch({
      type: SET_SITE_INFO,
      payload: data,
    });
    return data.system_name || "";
  }, [dispatch]);

  const loadStatus = useCallback(async () => {
    let system_name = "";
    try {
      const res = await API.get("/api/status", { disableErrorToast: isLocalPreview() });
      const { success, data } = res.data;
      if (success) {
        if (!data.chat_link) {
          delete data.chat_link;
        }
        localStorage.setItem("siteInfo", JSON.stringify(data));
        localStorage.setItem("quota_per_unit", data.quota_per_unit);
        localStorage.setItem("display_in_currency", data.display_in_currency);
        dispatch({ type: SET_SITE_INFO, payload: data });
        if (data.system_name) {
          system_name = data.system_name;
        }
      } else {
        system_name = loadBackupSiteInfo();
        if (!isLocalPreview()) {
          showError("无法正常连接至服务器！");
        }
      }
    } catch (error) {
      system_name = loadBackupSiteInfo();
      if (!isLocalPreview()) {
        showError("无法正常连接至服务器！");
      }
    }

    if (system_name) {
      document.title = system_name;
    }
  }, [dispatch, loadBackupSiteInfo]);

  useEffect(() => {
    loadStatus().then();
  }, [loadStatus]);

  return (
    <LoadStatusContext.Provider value={loadStatus}>
      {" "}
      {children}{" "}
    </LoadStatusContext.Provider>
  );
};

export default StatusProvider;
